export enum Languages {
  "ru" = "russian",
  "en" = "english",
}
